module.exports = __webpack_public_path__ + "public/img/bg-certif-graduation.3c657cb2.png";